"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawEventResponseToJSON = exports.RawEventResponseFromJSONTyped = exports.RawEventResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function RawEventResponseFromJSON(json) {
    return RawEventResponseFromJSONTyped(json, false);
}
exports.RawEventResponseFromJSON = RawEventResponseFromJSON;
function RawEventResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': !(0, runtime_1.exists)(json, '_id') ? undefined : json['_id'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'gameId': !(0, runtime_1.exists)(json, 'gameId') ? undefined : json['gameId'],
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : json['data'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !(0, runtime_1.exists)(json, 'updatedAt') ? undefined : json['updatedAt'],
    };
}
exports.RawEventResponseFromJSONTyped = RawEventResponseFromJSONTyped;
function RawEventResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'userId': value.userId,
        'gameId': value.gameId,
        'data': value.data,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.RawEventResponseToJSON = RawEventResponseToJSON;
